// extracted by mini-css-extract-plugin
export default {"reviewCardWrapper":"Testimonials_reviewCardWrapper__Ft0ba"};